


























































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Label from '@/components/common/elements/Label.vue';
import Input from '@/components/common/elements/Input.vue';
import Select from '@/components/common/elements/Select.vue';
import { SelectProps } from '@/constants/form/types';

@Component({
  components: { Label, Input, Select }
})
export default class InputUnitPriceQuantityCalculation extends Vue {
  // == 項目共通要素
  // name要素名
  @Prop({ default: '数量' })
  quantityLabelName!: string;
  @Prop({ default: '単位' })
  unitLabelName!: string;
  @Prop({ default: '単価' })
  unitPriceLabelName!: string;
  @Prop({ default: '金額' })
  amountLabelName!: string;
  // ラベルテキスト
  @Prop({ default: '数量' })
  quantityLabelText!: string;
  @Prop({ default: '単位' })
  unitLabelText!: string;
  @Prop({ default: '単価' })
  unitPriceLabelText!: string;
  @Prop({ default: '金額' })
  amountLabelText!: string;
  // 追加設定するクラス
  @Prop({ default: '' })
  labelClass?: string;
  // disabled設定
  @Prop({ default: false })
  isDisabled?: boolean;
  // フィールドの初期値群(数量;単価;単位)
  @Prop({ default: '' })
  value?: string;
  // フィールドのname要素群(数量;単価;単位;明細行を示す添字"[n]")
  @Prop()
  name!: string;

  // == 数値入力フィールド（数量・単価・金額）関係
  // フィールドのプレースホルダ文字列
  @Prop({ default: '' })
  numInputPlaceholder?: string;
  // フィールドの最大文字列長
  @Prop({ default: '' })
  numInputMaxlength?: string;
  // フィールドのカンマ区切り表示設定
  @Prop({ default: false })
  isQuantityCommaNumber?: boolean;
  @Prop({ default: false })
  isUnitPriceCommaNumber?: boolean;
  @Prop({ default: false })
  isAmountCommaNumber?: boolean;
  /** 数量フィールドの入力値 */
  private quantityValue = 0;
  /** 単価フィールドの入力値 */
  private unitPriceValue = 0;
  /** 金額フィールドの入力値 */
  private amountValue = 0;

  // == 選択入力フィールド（単位）関係
  // フィールドに表示する選択肢
  @Prop({ default: () => ({ name: '', options: [] }) })
  private selectData!: SelectProps;
  /** 単位フィールドの入力値 */
  private selectText = '';

  mounted() {
    this.setEachValueToForm();
  }

  private setEachValueToForm() {
    // 数量・単価・単位の初期値設定
    // "value"には"数量;"単価;単位"というテキストで入っている
    if (this.value) {
      this.quantityValue = Number(this.value.split(';')[0]);
      this.unitPriceValue = Number(this.value.split(';')[1]);
      this.amountValue = this.quantityValue * this.unitPriceValue;
      this.selectText = (this.value.split(';')[2] !== 'undefined' ? this.value.split(';')[2] : '');
    }
  }

  @Watch('value')
  onChangeValue() {
    this.setEachValueToForm();
  }

  @Emit('inputOperation')
  onInputNumField(data: { name: string; value: string; type?: string }) {
    const str = data.name.slice(0, data.name.lastIndexOf('['));
    if (str === this.name.split(';')[0]) {
      this.quantityValue = Number(data.value);
    } else if (str === this.name.split(';')[1]) {
      this.unitPriceValue = Number(data.value);
    }
    this.amountValue = this.quantityValue * this.unitPriceValue;
    data.type = 'number';
    return data;
  }

  @Emit('inputOperation')
  onInputSelField(value: { [k: string]: string }) {
    const val = typeof value === 'string' ? value : value.text;
    return ({name: this.name.split(';')[2] + this.name.split(';')[3], value: val});
  }
}
